module.exports = __webpack_public_path__ + "img/zhangxue.aab5d3eb.jpg";